import { TStennClientsServiceApplicationPortEnumsClientsBuyerStatus } from '@app/core/__generated__';
import { EBuyerState } from '@app/pages/Buyers/BuyersPage/types';
import { match } from 'ts-pattern';

export const showBuyerFinanceData = (buyerStatus?: TStennClientsServiceApplicationPortEnumsClientsBuyerStatus) => {
  return match(buyerStatus)
    .with(EBuyerState.Unknown, EBuyerState.UnderReview, EBuyerState.FinancingDenied, () => false)
    .otherwise(() => true);
};
